<div class="alert alert-danger margin-0" role="alert" [attr.data-test-id]="'noAccessMessageText'"> <strong>No Access</strong> Login does not have access to this screen.</div>
